/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import includes from "lodash/includes";
import filter from "lodash/filter";
import isEmpty from "lodash/isEmpty";
import sortBy from "lodash/sortBy";
import isUndefined from "lodash/isUndefined";

const AddOnSelection = ({
  items,
  defaultAddons,
  initialItems,
  onSelect,
  hidden_addons,
  visible_addons,
}) => {
  let visibleAddons = filter(items, item => {
    return (
      ((!includes(hidden_addons, item.name) && isUndefined(visible_addons)) ||
        includes(visible_addons, item.name)) &&
      !item.hidden
    );
  });
  visibleAddons = sortBy(visibleAddons, ["priority"]);
  const itemCount = get(visibleAddons, "length", 0);
  const [moreItemCount, setMoreItemCount] = useState(initialItems || itemCount);

  console.log("defaultAddons", defaultAddons)
  useEffect(() => {
    if (!isEmpty(defaultAddons)) {
      for (const item of items) {
        if (
          !item.selected &&
          includes(defaultAddons, item.name || item.title || item.id)
        ) {
          onSelect(item.id, true);
        }
      }
    }
  }, [defaultAddons, items, onSelect]);

  useEffect(() => {
    if (!moreItemCount && !initialItems && itemCount) {
      setMoreItemCount(itemCount);
    }
  }, [moreItemCount, initialItems, itemCount]);

  return (
    <></>
  );
};

AddOnSelection.defaultProps = {
  title: "",
  items: [],
  see_more_text: "see_more_addons",
  see_less_text: "see_less_addons",
  theme: "blue"
};

AddOnSelection.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired
};

export default AddOnSelection;
